import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

export default class ModalDiceGameAccess extends Component {
    state = { loading: false };

    setAccess = async (blocked) => {
        if (this.state.loading) return;
        this.setState({ loading: true });
        try {
            const response = await axios.post(global.config.apiDomain + '/mc-user/web/admin/dice-game-access', {
                id: this.props.account.id,
                blocked,
            });
            if (response.data.status === 'OK') {
                window.$('#modalDiceGameAccess').modal('hide');
                toast.success(response.data.message);
            } else {
                toast.warning(response.data.message || 'Cập nhật trạng thái game thất bại');
            }
        } catch (error) {
            toast.error('Cập nhật trạng thái game thất bại. Vui lòng thử lại.');
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { account } = this.props;
        const { loading } = this.state;
        return (
            <div className="modal fade" id="modalDiceGameAccess" tabIndex={-1} role="dialog"
                 aria-labelledby="diceGameAccessTitle" aria-hidden="true" data-backdrop="static">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="diceGameAccessTitle">Chặn game</h5>
                            <button type="button" className="close" data-dismiss="modal" disabled={loading} aria-label="Đóng">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Mở game để người dùng thấy game và có thể đặt cược.</p>
                            <p className="mb-0">Chặn game sẽ ẩn game và khóa đặt cược cho đến khi được mở lại,
                                kể cả khi người dùng nạp tiền đủ điều kiện.</p>
                            {account.featureBanStatus && account.featureBanStatus.useIcoin && (
                                <p className="text-warning mt-3 mb-0">Tài khoản đang bị chặn tiêu tiền.
                                    Cần gỡ chặn tiêu tiền để đặt cược sau khi mở game.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            {loading && <span role="status">Đang cập nhật...</span>}
                            <button type="button" className="btn btn-success" disabled={loading}
                                    onClick={() => this.setAccess(false)}>Mở game</button>
                            <button type="button" className="btn btn-danger" disabled={loading}
                                    onClick={() => this.setAccess(true)}>Chặn game</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
